import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './styles.css'

class CustomMarker extends Component {
  static propTypes = {
    marker: PropTypes.shape({
      id: PropTypes.string.isRequired,
      duration: PropTypes.shape({
        days: PropTypes.number,
      }),
      isCurrent: PropTypes.bool,
    }).isRequired,
    markerSelected: PropTypes.func.isRequired,
  }

  state = {
    hovering: false,
    detailsDisplayed: false,
  }

  onClick = () => {
    this.props.markerSelected({ eventId: this.props.marker.id, })
  }

  onMouseOver = () => {
    this.setState({
      hovering: true,
    })
  }

  onMouseOut = () => {
    this.setState({
      hovering: false,
    })
  }

  render() {
    const { isCurrent } = this.props.marker
    const { hovering } = this.state
    const pulse = isCurrent
      ? <div className="custom-marker__point--pulse" />
      : <div className="custom-marker__point" />
    const counter = this.props.marker.duration ? this.props.marker.duration.days : ''
    const backgroundMarkerClass = classNames('custom-marker__pin custom-marker__pin--bounce custom-marker__pin--background')
    const markerClass = classNames('custom-marker__pin custom-marker__pin--bounce', {
      'custom-marker__pin--dot': !this.props.marker.duration,
    },
    { 'custom-marker__pin--hovering': hovering, }
  )
    return (
      <div>
        <div
          className="custom-marker__container"
          onClick={this.onClick}
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
          role="presentation"
        >
          <div className={backgroundMarkerClass} />
          <div className={markerClass}>
            <div className="custom-marker__pin--count">
              <span>{counter}</span>
            </div>
          </div>
          {pulse}
        </div>
      </div>
    )
  }
}

export default CustomMarker



// WEBPACK FOOTER //
// ./src/components/CustomMarker/index.js